import './ProgramPage.css'

import React from 'react'
import { withProps } from 'recompose'
import Markdown from 'react-markdown'

import { getProgramContent, getTracks } from '../app/selectors'
import ScheduleTable from './ScheduleTable'
import content from '../content'

const ProgramPage = ({ text, tracks }) => {
  return (
    <div>
      <Markdown source={text} />
      <ScheduleTable tracks={tracks} />
    </div>
  )
}

const tracks = getTracks(content)
const programContent = getProgramContent(content)

const withPageContent = withProps({
  text: programContent.text,
  tracks,
})

export default withPageContent(ProgramPage)



// WEBPACK FOOTER //
// ./src/containers/ProgramPage.js